import React, { useContext } from "react";
import { __RouterContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Icon, Image, Menu } from "semantic-ui-react";
import _ from "lodash";

import logo from "../../logo.svg";
import { Link } from "react-router-dom";

import { tabNames } from "../../constants";

const BottomNavbar = ({ partyName }) => {
  const context = useContext(__RouterContext);

  let activeTab;
  const { search } = context.location;
  console.log("context");
  console.log(context);

  if (_.includes(search, tabNames.SEARCH)) {
    activeTab = tabNames.SEARCH;
  } else if (_.includes(search, tabNames.SETTINGS)) {
    activeTab = tabNames.SETTINGS;
  } else {
    activeTab = tabNames.PARTY;
  }

  return (
    <Menu
      fixed="bottom"
      style={styles.main}
      inverted
      widths={3}
      icon={"labeled"}
    >
      <Container>
        <Menu.Item
          as={Link}
          to={{ search: `?tab=${tabNames.SETTINGS}` }}
          header
          replace
          active={activeTab === tabNames.SETTINGS}
        >
          <Icon name={"bars"} />
          More
        </Menu.Item>
        <Menu.Item
          as={Link}
          to={{ search: `?tab=${tabNames.SEARCH}` }}
          header
          replace
          active={activeTab === tabNames.SEARCH}
        >
          <Icon name={"search"} />
          Search
        </Menu.Item>
        <Menu.Item
          as={Link}
          to={partyName ? `/p/${partyName}` : "/p"}
          header
          replace
          active={activeTab === tabNames.PARTY}
        >
          <Icon as={Image} size="mini" src={logo} />
          Spotbox
        </Menu.Item>
      </Container>
    </Menu>
  );
};

BottomNavbar.propTypes = {
  partyName: PropTypes.string,
};

const styles = {
  main: {
    maxWidth: "100vw",
    width: "100%",
  },
};

export default BottomNavbar;
